import { Button, Flex, Text } from '@mantine/core';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { useNachversandStore } from '../../../../../store/NachversandStore';
import { bodyTextProps } from '../utils';

export const Part2BookingButton = observer(({ label }: { label: string }) => {
  const { t } = useTranslation('versand');
  const { bookingLink, bookingLinkFailed } = useNachversandStore();

  return (
    <Flex direction="column" gap="4px" style={{ alignSelf: 'flex-start' }}>
      <Button
        component="a"
        href={bookingLink ?? undefined}
        target="_blank"
        rel="noopener noreferrer"
        size="sm"
        disabled={!bookingLink}
        style={{ alignSelf: 'flex-start' }}
      >
        {label}
      </Button>
      {bookingLinkFailed && (
        <Text {...bodyTextProps} size="sm">
          {t('BookingLinkFailed')}
        </Text>
      )}
    </Flex>
  );
});
